// ──────────────────────────── Pointage Status ────────────────────────────
// Maps the tolerance statut (PointageStatut enum: NORMAL, ANTICIPE, RETARD,
// HORS_CRENEAU) to display-ready configuration (canonical shape, plan §2.5.2).
// `token` is an L2.5 semantic token — StatusBadge resolves it to --status-<token>.

import type { StatusConfig } from "@components/display/StatusBadge";
import { CheckCircle2, Clock, TriangleAlert, XCircle } from "lucide-react";

export const POINTAGE_STATUT = {
  NORMAL: {
    code: "NORMAL",
    label: "À l'heure",
    token: "completed",
    icon: CheckCircle2,
  },
  ANTICIPE: {
    code: "ANTICIPE",
    label: "Anticipé",
    token: "in-progress",
    icon: Clock,
  },
  RETARD: {
    code: "RETARD",
    label: "Retard",
    token: "overdue",
    icon: TriangleAlert,
  },
  HORS_CRENEAU: {
    code: "HORS_CRENEAU",
    label: "Hors créneau",
    token: "rejected",
    icon: XCircle,
  },
} as const satisfies Record<string, StatusConfig>;

export type PointageStatutConfig = StatusConfig;
